module.exports = __webpack_public_path__ + "media/images/companies/fbs-d0f932770df78f22e3d62c0e5d9caca8.png";